import Render from 'components/render';
import { selectUserLoginCount } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

import UserJourneyCardsModal from './UserJourneyCardModal';
import useUserJourneyCard from './useUserJourneyCard';

const UserJourneyCard = () => {
  const card = useUserJourneyCard();
  const userLoginCount = useAppSelector(selectUserLoginCount) as number;
  const showUserJourneyCardsModal = Boolean(card) && userLoginCount > 1;

  return (
    <Render when={showUserJourneyCardsModal}>
      <UserJourneyCardsModal card={card!} />
    </Render>
  );
};

UserJourneyCard.displayName = 'UserJourneyCard';

export default UserJourneyCard;
